export default () => ({
  show: false,
  address: {
    id: null,
    label: null,
    zip: null,
    street: null,
    number: null,
    complement: null,
    district: null,
    city: null,
    state: 'PR',
    correspondence: false
  },
  addresses: [],
  entity: 'address',
  entities: 'addresses',
  prefixRouter: 'settings.addresses',
  nextStepButtonAfterSave: [
    {
      icon: '',
      text: 'OK',
      name: 'settings.addresses.index',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/settings/addresses/resources/data.js